module.exports = __webpack_public_path__ + "img/core-feature-2.496ef006.png";